var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxTissue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 288L448 96H338.596C308.381 96 281.555 76.664 272 48C262.445 19.334 235.619 0 205.404 0H64L128 288H384ZM0 480C0 497.672 14.326 512 32 512H480C497.674 512 512 497.672 512 480V416H0V480ZM480 224H439.064L417.73 288H432C440.836 288 448 295.164 448 304S440.836 320 432 320H80C71.164 320 64 312.836 64 304S71.164 288 80 288H95.219L80.996 224H32C14.326 224 0 238.326 0 256V384H512V256C512 238.326 497.674 224 480 224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTissue);
export default __webpack_public_path__ + "static/media/box-tissue.fe2125cca822032849785904cfcdbc63.svg";
export { ForwardRef as ReactComponent };